import { Component, input } from '@angular/core';
import type { ToolId } from '@app/core/services/build-tool.service';

@Component({
  selector: 'app-tool-button',
  host: {
    class: 'landscape:block landscape:w-full',
    '[attr.data-coachmark]': 'id() && "tool-" + id()',
  },
  template: `
    <div
      class="flex min-w-36 shrink-0 flex-col overflow-hidden rounded-lg border border-slate-700 bg-slate-800 text-slate-200 transition-colors landscape:w-full"
      [class.opacity-40]="!affordable()"
    >
      <button
        type="button"
        class="flex min-w-0 flex-1 cursor-pointer items-center gap-2 px-2.5 py-2 text-left text-sm disabled:cursor-not-allowed"
        [disabled]="!affordable()"
        [attr.title]="tooltip()"
      >
        <span class="flex size-9 shrink-0 items-center justify-center rounded-md bg-slate-950/60">
          @if (thumbnailUrl(); as url) {
            <img [src]="url" alt="" class="size-8" draggable="false" />
          }
        </span>
        <span class="min-w-0 flex-1">
          <span class="flex items-center gap-1.5 font-semibold">{{ label() }}</span>
          <span class="flex items-baseline gap-1 text-[11px] text-slate-400">
            <span class="min-w-0 flex-1 truncate">{{ detail() }}</span>
            @if (cost() !== null) {
              <span class="shrink-0 text-emerald-400">Ƶ{{ cost() }}</span>
            }
          </span>
        </span>
      </button>
      @if (docsUrl(); as url) {
        <a
          [href]="url"
          target="_blank"
          rel="noopener"
          class="block border-t border-slate-950/40 bg-slate-950/30 px-2.5 py-1 text-[10px] text-sky-400 hover:text-sky-300 hover:underline"
        >
          RxJS docs ↗
        </a>
      }
    </div>
  `,
})
export class ToolButtonComponent {
  readonly id = input<ToolId | null>(null);
  readonly label = input.required<string>();
  readonly detail = input.required<string>();
  readonly tooltip = input<string | undefined>(undefined);
  readonly cost = input<number | null>(null);
  readonly thumbnailUrl = input<string | undefined>(undefined);
  readonly affordable = input(true);
  readonly docsUrl = input<string | undefined>(undefined);
}
